// @flow
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import i18n from "i18next";

// get the languages
const Languages = [
  { id: "english", name: "English", iso: "en" },
  {
    id: "german",
    name: "German",
    iso: "de",
  },
];

const getBrowserLanguage = () => {
  let lang = Languages.find(
    (element) => element.iso === i18n.language.substring(0, 2)
  );
  if (lang) {
    return lang;
  }
  return Languages[0];
};

const LanguageDropdown = () => {
  const [language, setLanguage] = useState(getBrowserLanguage());

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const location = useLocation();
  /*
   * toggle language-dropdown
   */
  const toggleDropdown = ({ dropdownOpen: boolean }) => {
    if (!dropdownOpen) {
   /*    logEvent(analytics, "topbar_language_dropdown"); */
    }
    setDropdownOpen(!dropdownOpen);
  };

  const changeLanguageHandler = (element) => {
    // Change the UI Language
    // TODO: Save Changes in Cookie or Session Storage
  /*   logEvent(analytics, "topbar_language_click", {
      selected_language: Languages[element.currentTarget.id].name,
    }); */
    setLanguage(Languages[element.currentTarget.id]);
    i18n.changeLanguage(Languages[element.currentTarget.id].iso);
  };

  return (
    <Dropdown show={dropdownOpen} onToggle={toggleDropdown}>
      <Dropdown.Toggle
        variant="link"
        id="dropdown-languages"
        as={Link}
        to={location.search ? location.search : location.pathname}
        onClick={toggleDropdown}
        className="nav-link dropdown-toggle arrow-none"
      >
        <i className="align-middle d-none d-sm-inline-block uil uil-globe topbar-globe-icon"></i>{" "}
        <span className="align-middle d-none d-sm-inline-block">
          {language.name}
        </span>
        <i className="mdi mdi-chevron-down d-none d-sm-inline-block align-middle"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu">
        <div onClick={toggleDropdown}>
          {Languages.map((lang, i) => {
            return (
              <div
                className="dropdown-item notify-item"
                id={i}
                key={lang.iso}
                lang={lang}
                onClick={changeLanguageHandler}
                role="button"
              >
                <span className="align-middle">{lang.name}</span>
                {/* //</Link> */}
              </div>
            );
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageDropdown;
